import {TYPE_GET_RAW, useFetcherSelector} from "../../mrf/redux/ReduxHelper";
import Flex from "../../mrf/layout/Flex";
import T from "../../mrf/utils/T";
import {Col} from "../../mrf/view/Grid";
import DashboardCard from "./DashboardCard";
import {UserIcon} from "../../styles/components/Icons";

export default function AdminCard() {
    const admin = useFetcherSelector({
        selector: state => state?.resources?.adminCard,
        type: TYPE_GET_RAW,
        resource: 'adminCard',
        endpoint: '/api/reports/adminDashboard',
        condition: () => true,
    });

    return (
        <DashboardCard icon={UserIcon} title='Users'>
            <Col size={12}>
                <b><T>Enabled Users</T>:</b>
                <Flex spaceX={6}>
                    <span/>
                    <ul>
                        <li>
                            <T>Admins</T>: {admin?.admins}
                        </li>
                        <li>
                            <T>Supervisors</T>: {admin?.supervisors}
                        </li>
                        <li>
                            <T>Operators</T>: {admin?.operators}
                        </li>
                        <li>
                            <T>Report Viewer</T>: {admin?.viewers}
                        </li>
                    </ul>
                </Flex>
            </Col>
            <Col size={12}>
                <b><T>Login statistics for the last 48 hours</T>:</b>
                <Flex spaceX={6}>
                    <span/>
                    <ul>
                        <li>
                            <T>Total login attempts</T>: {admin?.loginsOver48h}
                        </li>
                        <li>
                            <T>Successful login attempts</T>: {admin?.successfulLoginsOver48hs}
                        </li>
                        <li>
                            <T>Failed login attempts</T>: {admin?.failedLoginsOver48h}
                        </li>
                    </ul>
                </Flex>
            </Col>
        </DashboardCard>
    );
}